const listaDeCtrlEstados = (state) => {
    if (!state.items || !Array.isArray(state.items)) {
        return [];
    }
    return state.items;
}

const loadingCtrlEstados = (state) => {
    return state.carregando
}

export {
    listaDeCtrlEstados,
    loadingCtrlEstados
}
